module.exports = __webpack_public_path__ + "static/media/selection.aa68643e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/selection.svg
// module id = 1410
// module chunks = 2